import { useCallback, useState } from 'react'

import type { FanResponseDto } from '@api'

import { useChats } from '../state/chats-provider'

export const useOpenChat = () => {
  const [isChatOpening, setIsChatOpening] = useState(false)

  const { openChat } = useChats()

  const handleOpenChat = useCallback(
    async (fanId: FanResponseDto['id']) => {
      setIsChatOpening(true)
      await openChat(fanId)
      setIsChatOpening(false)
    },
    [openChat],
  )

  return {
    isChatOpening,
    handleOpenChat,
  }
}
